/* =====================================================
  Bioteine. Cart Drawer + Upsells + Reserved Timer
  Loaded after bioteine.js
  ===================================================== */
(function(){
  'use strict';
  if (!window.BT) window.BT = {};

  /* -------- Money formatter (NL fallback, Shopify-native preferred) -------- */
  BT.formatMoney = function(cents, symbol) {
  if (typeof window.Shopify !== 'undefined' && typeof window.Shopify.formatMoney === 'function') {
  try { return window.Shopify.formatMoney(cents); } catch(e) {}
  }
  symbol = symbol || '€';
  const eur = (cents / 100);
  return symbol + eur.toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  /* =====================================================
  RESERVED TIMER. 10 min countdown, resets on ATC
  ===================================================== */
  BT.Timer = {
  KEY: 'bt_cart_reserved_until',
  interval: null,

  reset(minutes) {
  const until = Date.now() + (minutes * 60 * 1000);
  localStorage.setItem(this.KEY, String(until));
  this.start();
  },
  clear() {
  localStorage.removeItem(this.KEY);
  this.stop();
  this.render(0);
  },
  getRemaining() {
  const until = parseInt(localStorage.getItem(this.KEY) || '0', 10);
  return Math.max(0, until - Date.now());
  },
  start() {
  this.stop();
  this.tick();
  this.interval = setInterval(() => this.tick(), 1000);
  },
  stop() {
  if (this.interval) { clearInterval(this.interval); this.interval = null; }
  },
  tick() {
  const ms = this.getRemaining();
  if (ms <= 0) {
  this.clear();
  return;
  }
  this.render(ms);
  },
  render(ms) {
  const el = document.querySelector('[data-bt-cart-timer]');
  const clock = document.querySelector('[data-bt-cart-timer-clock]');
  if (!el || !clock) return;
  if (ms <= 0) {
  el.hidden = true;
  return;
  }
  el.hidden = false;
  const totalSec = Math.ceil(ms / 1000);
  const min = Math.floor(totalSec / 60);
  const sec = totalSec % 60;
  clock.textContent = String(min).padStart(2,'0') + ':' + String(sec).padStart(2,'0');
  }
  };

  /* =====================================================
  CART DRAWER
  ===================================================== */
  BT.CartDrawer = {
  el: null,
  cart: null,
  settings: {
  freeShipThreshold: 4500, // cents
  reserveMinutes: 10,
  currencySymbol: '€'
  },

  init() {
  this.el = document.querySelector('[data-bt-cart-drawer]');
  if (!this.el) return;

  // Read settings from drawer dataset
  this.settings.freeShipThreshold = parseInt(this.el.dataset.freeShipThreshold || '0', 10);
  this.settings.texts = {
    empty: this.el.dataset.textShipbarEmpty || 'Voeg %%amount%% toe voor gratis verzending',
    progress: this.el.dataset.textShipbarProgress || 'Nog %%amount%% tot gratis verzending',
    unlocked: this.el.dataset.textShipbarUnlocked || 'Je hebt gratis verzending!',
    free: this.el.dataset.textFree || 'Gratis',
    calc: this.el.dataset.textCalc || 'Berekend bij checkout'
  };
  this.settings.reserveMinutes = parseInt(this.el.dataset.reserveMinutes || '10', 10);
  this.settings.currencySymbol = this.el.dataset.currencySymbol || '€';

  // Close handlers
  this.el.querySelectorAll('[data-bt-cart-close]').forEach(b => {
  b.addEventListener('click', () => this.close());
  });
  document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' && this.el.classList.contains('is-open')) this.close();
  });

  // Cart icon → open drawer (prevent default link nav)
  // Skip on cart page itself
  const isCartPage = document.body.classList.contains('template-cart');
  if (!isCartPage) {
  document.querySelectorAll('[data-bt-cart-toggle]').forEach(el => {
  el.addEventListener('click', (e) => {
  e.preventDefault();
  this.open();
  });
  });
  }

  // Upsell add buttons. Event delegation, works for all current & future buttons site-wide
  document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-bt-upsell-add]');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
  if (btn.dataset.btBusy === '1') return;
  this.handleUpsellAdd(btn);
  });

  // Discount apply
  const discountBtn = this.el.querySelector('[data-bt-discount-apply]');
  const discountInput = this.el.querySelector('[data-bt-discount-input]');
  discountBtn?.addEventListener('click', () => this.applyDiscount(discountInput.value));
  discountInput?.addEventListener('keypress', (e) => {
  if (e.key === 'Enter') { e.preventDefault(); this.applyDiscount(discountInput.value); }
  });

  // Initial fetch
  this.fetch();

  // Start timer if there's an active reservation
  if (BT.Timer.getRemaining() > 0) BT.Timer.start();

  // Listen for cart:updated from other components
  document.addEventListener('bt:cart:updated', (e) => this.render(e.detail));
  },

  open() {
  if (!this.el) return;
  this.el.classList.add('is-open');
  this.el.setAttribute('aria-hidden', 'false');
  document.body.classList.add('bt-no-scroll');
  // Re-fetch to be sure we're showing latest
  this.fetch();
  },
  close() {
  if (!this.el) return;
  this.el.classList.remove('is-open');
  this.el.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('bt-no-scroll');
  },

  async fetch() {
  try {
  const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' }});
  const cart = await res.json();
  // Reset recs flag if cart contents changed (so we get fresh recs)
  const newSig = (cart.items || []).map(i => i.product_id).join(',');
  if (this._lastCartSig !== newSig) {
  this._recsFetched = false;
  this._lastCartSig = newSig;
  }
  this.cart = cart;
  this.render(cart);
  document.dispatchEvent(new CustomEvent('bt:cart:fetched', { detail: cart }));
  } catch(err) { console.error('Cart fetch failed', err); }
  },

  render(cart) {
  if (!cart) return;
  this.cart = cart;

  // Update count badges everywhere
  document.querySelectorAll('[data-bt-cart-count], [data-cart-count]').forEach(el => {
  el.textContent = cart.item_count;
  el.classList.toggle('is-empty', cart.item_count === 0);
  });

  // Empty vs filled UI
  const emptyEl = this.el.querySelector('[data-bt-cart-empty]');
  const linesEl = this.el.querySelector('[data-bt-cart-lines]');
  const footerEl = this.el.querySelector('[data-bt-cart-footer]');
  const upsellEl = this.el.querySelector('[data-bt-cart-upsell]');
  const isEmpty = cart.item_count === 0;

  if (emptyEl) emptyEl.hidden = !isEmpty;
  if (linesEl) linesEl.hidden = isEmpty;
  if (footerEl) footerEl.hidden = isEmpty;
  if (upsellEl) upsellEl.hidden = isEmpty;

  // Render lines
  if (!isEmpty) this.renderLines(cart);

  // Ship progress bar (always rendered, even when empty)
  this.renderShipBar(cart);

  // Summary
  this.renderSummary(cart);

  // Upsells: filter out products already in cart
  this.filterUpsells(cart);

  // Timer: stop if cart is empty; start if cart has items but no active reservation yet
  if (isEmpty) {
  BT.Timer.clear();
  } else if (BT.Timer.getRemaining() <= 0) {
  BT.Timer.reset(this.settings.reserveMinutes);
  } else {
  BT.Timer.start();
  }
  },

  renderLines(cart) {
  const lines = this.el.querySelector('[data-bt-cart-lines]');
  if (!lines) return;
  lines.innerHTML = '';

  cart.items.forEach((item) => {
  const li = document.createElement('li');
  li.className = 'bt-cart-line';
  li.dataset.key = item.key;
  li.dataset.lineKey = item.key;

  const compareHtml = (item.original_price > item.final_price)
  ? `<span class="bt-cart-line__compare">${BT.formatMoney(item.original_price, this.settings.currencySymbol)}</span>`
  : '';

  const sellingPlan = item.selling_plan_allocation
  ? `<div class="bt-cart-line__plan">Abonnement: ${this.escape(item.selling_plan_allocation.selling_plan.name)}</div>`
  : '';

  const variantTitle = (item.variant_title && item.variant_title !== 'Default Title')
  ? `<div class="bt-cart-line__variant">${this.escape(item.variant_title)}</div>` : '';

  li.innerHTML = `
  <a href="${item.url}" class="bt-cart-line__img-wrap" aria-label="${this.escape(item.product_title)}">
  ${item.image ? `<img class="bt-cart-line__img" src="${this.imageUrl(item.image, 160)}" alt="" loading="lazy" width="80" height="80">` : ''}
  </a>
  <div class="bt-cart-line__info">
  <a href="${item.url}" class="bt-cart-line__title">${this.escape(item.product_title)}</a>
  ${variantTitle}
  ${sellingPlan}
  <div class="bt-cart-line__row">
  <div class="bt-cart-line__qty" data-bt-qty>
  <button type="button" data-bt-qty-dec aria-label="Verlaag aantal">−</button>
  <input type="number" value="${item.quantity}" min="0" inputmode="numeric" aria-label="Aantal" data-bt-qty-input>
  <button type="button" data-bt-qty-inc aria-label="Verhoog aantal">+</button>
  </div>
  <div class="bt-cart-line__price">
  ${compareHtml}
  <span>${BT.formatMoney(item.final_line_price, this.settings.currencySymbol)}</span>
  </div>
  </div>
  <button type="button" class="bt-cart-line__remove" data-bt-remove aria-label="Verwijder ${this.escape(item.product_title)}">
  Verwijderen
  </button>
  </div>
  `;
  lines.appendChild(li);
  });

  // Bind line item events
  lines.querySelectorAll('.bt-cart-line').forEach(line => {
  const key = line.dataset.key;
  const input = line.querySelector('[data-bt-qty-input]');
  const dec = line.querySelector('[data-bt-qty-dec]');
  const inc = line.querySelector('[data-bt-qty-inc]');
  const remove = line.querySelector('[data-bt-remove]');

  dec?.addEventListener('click', () => {
  const q = Math.max(0, parseInt(input.value, 10) - 1);
  this.changeQty(key, q);
  });
  inc?.addEventListener('click', () => {
  const q = parseInt(input.value, 10) + 1;
  this.changeQty(key, q);
  });
  input?.addEventListener('change', () => {
  const q = Math.max(0, parseInt(input.value, 10) || 0);
  this.changeQty(key, q);
  });
  remove?.addEventListener('click', () => this.changeQty(key, 0));
  });
  },

  renderShipBar(cart) {
  const text = this.el.querySelector('[data-bt-shipbar-text]');
  const fill = this.el.querySelector('[data-bt-shipbar-fill]');
  if (!text || !fill) return;

  const threshold = this.settings.freeShipThreshold;
  if (!threshold) { return; }
  const total = cart.total_price;
  const remaining = threshold - total;

  if (cart.item_count === 0) {
  fill.style.width = '0%';
  text.innerHTML = this.settings.texts.empty.replace('%%amount%%', `<strong>${BT.formatMoney(threshold, this.settings.currencySymbol)}</strong>`);
  fill.classList.remove('is-complete');
  } else if (remaining > 0) {
  const pct = Math.min(100, (total / threshold) * 100);
  fill.style.width = pct + '%';
  text.innerHTML = this.settings.texts.progress.replace('%%amount%%', `<strong>${BT.formatMoney(remaining, this.settings.currencySymbol)}</strong>`);
  fill.classList.remove('is-complete');
  } else {
  fill.style.width = '100%';
  fill.classList.add('is-complete');
  text.innerHTML = `<strong><svg class="bt-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M8 12l3 3 5-6"/></svg> ${this.settings.texts.unlocked}</strong>`;
  }

  // Also update sticky bar shipbar if present (same logic, different element)
  const stickyText = document.querySelector('[data-bt-sticky-shipbar-text]');
  const stickyFill = document.querySelector('[data-bt-sticky-shipbar-fill]');
  if (stickyText && stickyFill) {
  stickyText.innerHTML = text.innerHTML;
  stickyFill.style.width = fill.style.width;
  }

  // Cart page shipbar
  const pageText = document.querySelector('[data-bt-cartpage-shipbar-text]');
  const pageFill = document.querySelector('[data-bt-cartpage-shipbar-fill]');
  if (pageText && pageFill) {
  pageText.innerHTML = text.innerHTML;
  pageFill.style.width = fill.style.width;
  pageFill.classList.toggle('is-complete', fill.classList.contains('is-complete'));
  }
  },

  renderSummary(cart) {
  const subtotalEl = this.el.querySelector('[data-bt-cart-subtotal]');
  const totalEl = this.el.querySelector('[data-bt-cart-total]');
  if (subtotalEl) subtotalEl.textContent = BT.formatMoney(cart.items_subtotal_price, this.settings.currencySymbol);
  if (totalEl) totalEl.textContent = BT.formatMoney(cart.total_price, this.settings.currencySymbol);

  // Shipping label. When above threshold, show "Gratis"
  const shippingEl = this.el.querySelector('[data-bt-cart-shipping]');
  if (shippingEl) {
  if (this.settings.freeShipThreshold > 0 && cart.total_price >= this.settings.freeShipThreshold) {
  shippingEl.innerHTML = '<strong style="color:var(--bt-sage-dark)">' + this.settings.texts.free + '</strong>';
  } else {
  shippingEl.textContent = this.settings.texts.calc;
  }
  }
  },

  filterUpsells(cart) {
  const track = this.el.querySelector('[data-bt-upsell-track]');
  if (!track) return;
  const inCartIds = new Set(cart.items.map(i => String(i.product_id)));

  // If we have static upsell cards (rendered server-side from collection), filter them
  const cards = track.querySelectorAll('.bt-upsell-card');
  if (cards.length > 0) {
  cards.forEach(card => {
  const pid = card.dataset.productId;
  card.style.display = inCartIds.has(pid) ? 'none' : '';
  });
  const visible = track.querySelectorAll('.bt-upsell-card:not([style*="display: none"])').length;
  const upsellWrap = this.el.querySelector('[data-bt-cart-upsell]');
  if (upsellWrap) upsellWrap.style.opacity = visible > 0 ? '1' : '0.4';
  return;
  }

  // No static upsells. Use Shopify product recommendations API for each cart item
  if (cart.items.length === 0) return;
  if (this._recsFetched) return; // only fetch once per drawer session
  this._recsFetched = true;

  // Get recs for first item in cart (most recently added)
  const firstItem = cart.items[cart.items.length - 1];
  fetch(`/recommendations/products.json?product_id=${firstItem.product_id}&limit=6&intent=related`)
  .then(r => r.json())
  .then(data => {
  if (!data.products || data.products.length === 0) {
  // Hide entire upsell block. No recs available
  const upsellWrap = this.el.querySelector('[data-bt-cart-upsell]');
  if (upsellWrap) upsellWrap.style.display = 'none';
  return;
  }
  // Normalize price: Shopify's /recommendations/products.json returns
  // variant.price as either a decimal string ("16.75") or an integer cents (1675),
  // depending on API version. Detect and convert to cents.
  const toCents = (v) => {
  if (v === null || v === undefined || v === '') return 0;
  const s = String(v);
  // If it contains a decimal separator -> dollars/euros, multiply by 100
  if (s.indexOf('.') !== -1 || s.indexOf(',') !== -1) {
  return Math.round(parseFloat(s.replace(',', '.')) * 100);
  }
  // Else it's already integer cents
  return parseInt(s, 10) || 0;
  };
  const html = data.products
  .filter(p => !inCartIds.has(String(p.id)) && p.available)
  .slice(0, 4)
  .map(p => {
  const v = p.variants && p.variants[0];
  if (!v) return '';
  const priceCents = toCents(v.price);
  const compareCents = toCents(v.compare_at_price);
  const compare = (compareCents > priceCents)
  ? `<span class="bt-upsell-card__compare">${BT.formatMoney(compareCents, this.settings.currencySymbol)}</span>` : '';
  return `
  <article class="bt-upsell-card" data-product-id="${p.id}">
  <a href="${p.url}" class="bt-upsell-card__img-wrap">
  ${p.featured_image ? `<img class="bt-upsell-card__img" src="${this.imageUrl(p.featured_image, 200)}" alt="" loading="lazy" width="80" height="80">` : ''}
  </a>
  <div class="bt-upsell-card__info">
  <a href="${p.url}" class="bt-upsell-card__title">${this.escape(p.title)}</a>
  <div class="bt-upsell-card__price">${compare}<span>${BT.formatMoney(priceCents, this.settings.currencySymbol)}</span></div>
  </div>
  <button class="bt-upsell-card__add" type="button" data-bt-upsell-add data-variant-id="${v.id}" aria-label="Voeg ${this.escape(p.title)} toe">
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 5v14M5 12h14"/></svg>
  <span>Toevoegen</span>
  </button>
  </article>
  `;
  }).join('');
  if (html) {
  track.innerHTML = html;
  } else {
  const upsellWrap = this.el.querySelector('[data-bt-cart-upsell]');
  if (upsellWrap) upsellWrap.style.display = 'none';
  }
  })
  .catch(() => {
  const upsellWrap = this.el.querySelector('[data-bt-cart-upsell]');
  if (upsellWrap) upsellWrap.style.display = 'none';
  });
  },

  async handleUpsellAdd(btn) {
  const id = btn.dataset.variantId;
  if (!id) return;
  btn.dataset.btBusy = '1';
  const span = btn.querySelector('span');
  const original = span ? span.textContent : btn.textContent;
  btn.classList.add('is-loading');
  if (span) span.textContent = 'Bezig…'; else btn.textContent = 'Bezig…';
  try {
  await this.addItem(id, 1);
  if (span) span.textContent = 'Toegevoegd'; else btn.textContent = 'Toegevoegd';
  btn.classList.add('is-added');
  setTimeout(() => {
  if (span) span.textContent = original; else btn.textContent = original;
  btn.classList.remove('is-added','is-loading');
  btn.dataset.btBusy = '';
  }, 1600);
  } catch(err) {
  if (span) span.textContent = 'Mislukt'; else btn.textContent = 'Mislukt';
  setTimeout(() => {
  if (span) span.textContent = original; else btn.textContent = original;
  btn.classList.remove('is-loading');
  btn.dataset.btBusy = '';
  }, 1600);
  }
  },

  async addItem(variantId, qty, properties) {
  const body = { id: variantId, quantity: qty || 1 };
  if (properties) body.properties = properties;
  const res = await fetch('/cart/add.js', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
  body: JSON.stringify(body)
  });
  if (!res.ok) {
  const err = await res.json().catch(() => ({}));
  this.showError(err.description || 'Kon product niet toevoegen');
  throw new Error('add failed');
  }
  await this.fetch();
  BT.Timer.reset(this.settings.reserveMinutes);
  document.dispatchEvent(new CustomEvent('bt:cart:added', { detail: { variantId, qty } }));

  // On cart page: reload to keep server-rendered totals in sync. Elsewhere: open drawer.
  if (document.body.classList.contains('template-cart')) {
  setTimeout(() => window.location.reload(), 600);
  } else {
  this.open();
  }
  },

  async changeQty(key, quantity) {
  try {
  const res = await fetch('/cart/change.js', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
  body: JSON.stringify({ id: key, quantity })
  });
  if (!res.ok) throw new Error('change failed');
  const cart = await res.json();
  this.render(cart);
  // Reset the reservation timer on every cart edit so the user gets
  // a fresh window after changing quantities or removing items.
  if (cart.item_count > 0) BT.Timer.reset(this.settings.reserveMinutes);
  document.dispatchEvent(new CustomEvent('bt:cart:updated', { detail: cart }));
  } catch(err) {
  console.error(err);
  this.showError('Kon hoeveelheid niet bijwerken');
  }
  },

  async applyDiscount(code) {
  if (!code || !code.trim()) return;
  try {
  // Shopify doesn't support discount codes via Ajax. Redirect to /discount/CODE
  window.location.href = '/discount/' + encodeURIComponent(code.trim()) + '?redirect=' + encodeURIComponent('/cart');
  } catch(err) { console.error(err); }
  },

  showError(msg) {
  // Lightweight toast
  let toast = document.querySelector('.bt-cart-toast');
  if (!toast) {
  toast = document.createElement('div');
  toast.className = 'bt-cart-toast';
  document.body.appendChild(toast);
  }
  toast.textContent = msg;
  toast.classList.add('is-visible');
  setTimeout(() => toast.classList.remove('is-visible'), 3200);
  },

  /* helpers */
  escape(str) {
  const div = document.createElement('div');
  div.textContent = String(str || '');
  return div.innerHTML;
  },
  imageUrl(src, width) {
  if (!src) return '';
  // Shopify CDN URLs accept ?width=XX
  const sep = src.includes('?') ? '&' : '?';
  return src + sep + 'width=' + width;
  }
  };

  /* =====================================================
  PATCH: replace BT.initAddToCart to open drawer
  ===================================================== */
  const originalATC = BT.initAddToCart;
  BT.initAddToCart = function() {
  document.querySelectorAll('[data-product-form]').forEach(form => {
  if (form.dataset.btBound) return;
  form.dataset.btBound = '1';
  form.addEventListener('submit', async (e) => {
  e.preventDefault();
  const btn = form.querySelector('[data-atc-btn]');
  const span = btn?.querySelector('span');
  const original = span?.textContent;
  if (btn) {
  btn.classList.add('is-loading');
  if (span) span.textContent = 'Toevoegen…';
  }
  try {
  const fd = new FormData(form);
  const res = await fetch('/cart/add.js', {
  method: 'POST',
  body: fd,
  headers: { 'Accept': 'application/json' }
  });
  if (!res.ok) {
  const err = await res.json().catch(() => ({}));
  throw new Error(err.description || 'Toevoegen mislukt');
  }
  await res.json();

  // Update cart, reset timer, open drawer (but skip drawer on cart page itself)
  await BT.CartDrawer.fetch();
  BT.Timer.reset(BT.CartDrawer.settings.reserveMinutes);
  if (!document.body.classList.contains('template-cart')) {
  BT.CartDrawer.open();
  } else {
  // On cart page, reload to refresh line items
  window.location.reload();
  return;
  }

  if (span) span.textContent = 'Toegevoegd';
  setTimeout(() => {
  if (btn) btn.classList.remove('is-loading');
  if (span) span.textContent = original || 'Toevoegen aan winkelwagen';
  }, 1500);
  } catch(err) {
  console.error(err);
  if (span) span.textContent = 'Mislukt. Probeer opnieuw';
  BT.CartDrawer.showError(err.message || 'Toevoegen mislukt');
  setTimeout(() => {
  if (btn) btn.classList.remove('is-loading');
  if (span) span.textContent = original || 'Toevoegen aan winkelwagen';
  }, 2200);
  }
  });
  });
  };

  /* =====================================================
  INIT
  ===================================================== */
  document.addEventListener('DOMContentLoaded', () => {
  BT.CartDrawer.init();
  BT.initAddToCart();
  });

})();
